import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';

export const PharmacyInconsistencyFieldType = types.compose(
  'PharmacyInconsistencyFieldType',
  BaseEntity,
  types
    .model({
      pharmacyInconsistencyFieldTypeId: types.identifierNumber,
      pharmacyFieldName: types.string,
    })
);
